<template>
	<div class="page padded">

		<div class="centered mw-narrow" >
			<div class="raised-box">
				<div class="p-box c-bg-grad-core t-invert t-invert-links">
					<h1>Login</h1>
					<p>Need an account? <router-link to="/register" >Register</router-link></p>
				</div>
				<div class="p-box">

					<LoginForm :autofocus="true" />

				</div>
			</div>

		</div>

	</div>
</template>

<script>

	import LoginForm from '../../forms/LoginForm';

	export default {
		components : {LoginForm},
	}

</script>